import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import _isEmpty from 'lodash/isEmpty'
import _every from 'lodash/every'
import _capitalize from 'lodash/capitalize'
import SearchIcon from 'react-icons/lib/fa/search'

import { filterSpeciesByType } from '../utils/filterUtils'
import SpeciesCard from '../components/SpeciesCard'
import Header from '../components/Header'
import Meta from '../components/Meta'
import CardContainer from '../components/CardContainer'
import { Page, Section, Container } from '../components/common'
import { H5 } from '../components/type'

import SpeciesFilter from '../components/SpeciesFilter'

class SpeciesList extends Component {
  constructor (props) {
    super(props)
    this.state = {
      displayFilter: false
    }
  }

  toggleFilter = () => {
    this.setState({ displayFilter: !this.state.displayFilter })
  }

  filterSpeciesByCategory (species, categories) {
    const filterCategory = item => {
      if (!item.fields.category) return false
      // check if any of items categories are active in current state
      const activeCats = item.fields.category.map(
        category => this.props.filters[this.props.type].categories[category]
      )
      return activeCats.filter(item => item).length > 0 // return true if any categories return true
    }
    if (_isEmpty(categories) || _every(categories)) {
      return species
    }
    return species.filter(item => {
      if (!filterCategory(item)) return false
      return true
    })
  }

  filterSpeciesByColour (species, colours) {
    const filterColour = item => {
      if (!item.fields.colour) return false
      // check if any of items colours are active in current state
      const activeColours = item.fields.colour.map(
        colour => this.props.filters[this.props.type].colours[colour]
      )
      return activeColours.filter(item => item).length > 0 // return true if any colours return true
    }
    if (_isEmpty(colours) || _every(colours)) return species
    return species.filter(item => {
      if (!filterColour(item)) return false
      return true
    })
  }

  filterSpeciesByConservationStatus (species, colours) {
    const filterConservationStatus = item => {
      if (!item.fields.conservationStatus) return false
      // check if any of items colours are active in current state
      const activeConservationStatus = item.fields.conservationStatus.map(
        conservationStatus =>
          this.props.filters[this.props.type].conservationStatus[
            conservationStatus
          ]
      )
      return activeConservationStatus.filter(item => item).length > 0 // return true if any colours return true
    }
    if (_isEmpty(colours) || _every(colours)) return species
    return species.filter(item => {
      if (!filterConservationStatus(item)) return false
      return true
    })
  }

  filterSpecies (species) {
    let filteredSpecies = species
    const sortByTitle = (a, b) => (a.fields.title < b.fields.title ? -1 : 1)
    filteredSpecies = filterSpeciesByType(filteredSpecies, this.props.type)
    filteredSpecies = this.filterSpeciesByCategory(
      filteredSpecies,
      this.props.filters[this.props.type].categories
    )
    filteredSpecies = this.filterSpeciesByColour(
      filteredSpecies,
      this.props.filters[this.props.type].colours
    )
    filteredSpecies = this.filterSpeciesByConservationStatus(
      filteredSpecies,
      this.props.filters[this.props.type].conservationStatus
    )
    return filteredSpecies.sort(sortByTitle)
  }

  renderSpeciesCards (items) {
    return items.map(item => <SpeciesCard key={item.sys.id} item={item} />)
  }

  render () {
    const { type, species } = this.props
    const visibleSpecies = this.filterSpecies(species)

    return (
      <Page>
        <Helmet title={_capitalize(type)} />
        <Meta
          title={_capitalize(type)}
          description={`Discover Springbrook ${_capitalize(type)}`}
          url={`https://discoverspringbrook.com/${type}`}
        />
        <Header
          small
          title={_capitalize(type)}
          button={{
            icon: SearchIcon,
            onClick: this.toggleFilter
          }}
        />
        <SpeciesFilter
          isVisible={this.state.displayFilter}
          filters={this.props.filters[this.props.type]}
          updateFilter={(key, filter) =>
            this.props.updateFilter(this.props.type, key, filter)
          }
          resetFilters={this.props.resetFilters}
          toggleFilter={this.toggleFilter}
          results={visibleSpecies}
        />
        {visibleSpecies.length > 0 && (
          <CardContainer>
            {this.renderSpeciesCards(visibleSpecies)}
          </CardContainer>
        )}
        {visibleSpecies.length <= 0 && (
          <Section>
            <Container taCenter>
              <H5 borderBottom>No species found.</H5>
              <p>You may need to adjust the filters</p>
            </Container>
          </Section>
        )}
      </Page>
    )
  }
}

SpeciesList.propTypes = {
  species: PropTypes.array,
  type: PropTypes.string.isRequired,
  filters: PropTypes.object,
  updateFilter: PropTypes.func.isRequired,
  resetFilters: PropTypes.func.isRequired,
  touchedFilters: PropTypes.object.isRequired
}

export default SpeciesList



// WEBPACK FOOTER //
// ./src/views/SpeciesList.js